var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65991 6.13735L11.6399 1.24683L16.6199 6.13735",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6399 14.2963V1.24683",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0799 14.2964V20.8211C22.0799 21.0632 21.984 21.3053 21.804 21.4748C21.624 21.6443 21.384 21.7532 21.132 21.7532H2.14795C1.89595 21.7532 1.65595 21.6564 1.47595 21.4748C1.29595 21.3053 1.19995 21.0632 1.19995 20.8211V14.2964",
    stroke: "#4F84F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPurple);
export default __webpack_public_path__ + "static/media/upload-purple.a160b46c04b852d4e29fc828af89ad82.svg";
export { ForwardRef as ReactComponent };